module.exports = __webpack_public_path__ + "static/media/2.d6107930.svg";